export default "__VITE_ASSET__b3r40H4r__"